import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import MobilityOptionsEditCategoryModal from '../../components/mobility-options/MobilityOptionsEditCategoryModal'
import { createCategory, removeCategory } from '../../state/actions/mobility-options/index'
import { IMobilityOptionCategoryObject, IStoreState } from '../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  return {
    categories: Object.values(state.mobilityOptionsCategories.items),
    onClose: ownProps.history.goBack
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onRemove: (category: IMobilityOptionCategoryObject) => {
      dispatch(removeCategory(category.id))
    },
    onCreate: (name: string) => {
      dispatch(createCategory(name))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobilityOptionsEditCategoryModal)



// WEBPACK FOOTER //
// ./src/containers/mobility-options/MobilityOptionsEditCategoryModal.ts